import * as React from "react";
import { SVGProps } from "react";
import { useTheme } from "next-themes";

const EunchurnLogo = (props: SVGProps<SVGSVGElement>) => {
  const { resolvedTheme } = useTheme();
  // const [mounted, setMounted] = React.useState(false);
  // React.useEffect(() => {
  //   setMounted(true);
  // }, []);

  // if (!mounted) {
  //   return null;
  // }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlSpace="preserve"
      viewBox="0 0 285.56 72.013"
      width={285.56 / 1.5}
      height={72.013 / 1.5}
      {...props}
    >
      <defs>
        {/* <linearGradient id="grad-light" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" style={{ stopColor: "rgb(68, 169, 232)", stopOpacity: 1 }} />
          <stop offset="100%" style={{ stopColor: "rgb(108, 213, 252)", stopOpacity: 1 }} />
        </linearGradient>
        <linearGradient id="grad-dark" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" style={{ stopColor: "rgb(108, 213, 252)", stopOpacity: 1 }} />
          <stop offset="100%" style={{ stopColor: "rgb(68, 169, 232)", stopOpacity: 1 }} />
        </linearGradient> */}
        <linearGradient id="grad-light" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop
            offset="0%"
            style={{ stopColor: "rgb(68, 169, 232)", stopOpacity: 1 }}
          />
          <stop
            offset="100%"
            style={{ stopColor: "rgb(112, 216, 206)", stopOpacity: 1 }}
          />
        </linearGradient>
        <linearGradient id="grad-dark" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop
            offset="0%"
            style={{ stopColor: "rgb(112, 216, 206)", stopOpacity: 1 }}
          />
          <stop
            offset="100%"
            style={{ stopColor: "rgb(68, 169, 232)", stopOpacity: 1 }}
          />
        </linearGradient>
      </defs>
      <path
        d="M88.242 350.527c5.953 13.825 14.871 25.668 26.774 33.571 12.89 8.886 25.781 13.82 40.652 13.82 15.863 0 29.742-3.949 41.641-11.844 11.902-7.902 21.812-18.765 27.765-32.59zm1964.198 64.18V245.859l-225.08 269.559V386.074h-5.95c-25.78 0-49.57-6.914-70.39-18.765v45.421h-1.99v1.977h-90.22V257.715c0-9.883-1.99-20.742-5.96-30.617-3.96-8.887-9.91-17.774-17.84-25.672-7.94-6.914-15.87-12.832-25.78-17.774-9.91-3.945-19.84-5.918-30.73-5.918-10.92 0-20.82 1.973-30.75 5.918-9.91 4.942-18.83 10.86-25.78 17.774-7.93 7.898-13.87 16.785-17.85 25.672-3.96 9.875-6.93 20.734-6.93 30.617v156.992h-89.24v-.988h-88.24v-88.867h-134.85v201.425h-90.23V259.688l-2.97 1.972c-6.94-9.875-15.87-16.789-26.77-22.715-9.92-5.918-20.83-9.863-32.72-11.847-10.91-1.969-22.81-1.969-34.709 1.984-10.902 1.973-20.82 7.891-30.731 14.805-8.925 7.898-16.859 16.785-22.808 26.66-5.949 9.871-9.918 20.73-11.902 32.582-.989 11.851-.989 23.695 1.984 34.562 3.969 14.809 8.926 25.668 13.883 32.582 5.953 7.899 15.863 14.809 28.754 23.696l-52.547 84.918c-20.824-12.836-38.672-28.633-53.543-49.371-7.934-9.871-13.879-19.746-19.832-31.598v40.484h-89.235V270.547L536.406 540.105V229.082c-6.937-6.914-15.863-12.844-24.785-16.797-9.918-3.945-19.828-6.906-30.738-6.906-10.906 0-20.82 2.961-30.738 6.906-9.915 3.953-17.844 9.883-25.782 17.774-6.937 6.914-12.883 15.8-17.843 25.683-3.965 9.867-5.95 19.742-5.95 30.602v156.008h-90.226v-78.993c-1.985 7.899-4.957 15.801-7.934 23.7-8.926 18.761-20.824 35.546-35.695 49.371-14.867 13.824-31.731 24.683-50.567 32.582-19.832 7.902-39.66 11.847-61.476 10.859-21.813 0-41.641-4.933-60.477-12.836-19.836-8.883-35.699-19.746-50.574-34.555-13.875-14.812-24.781-31.597-32.719-51.347C2.972 362.371 0 341.641 0 320.902l.992-42.457c0-20.73 4.957-41.472 12.89-60.234 8.919-18.758 19.829-35.543 34.704-49.363 14.871-13.828 31.727-24.688 51.555-32.59 18.839-7.899 39.66-11.844 60.484-10.86h12.891l-1.989 81.954h-11.894c-17.848 0-33.711 4.933-47.594 16.789-13.879 11.843-22.805 26.66-26.77 43.441l226.063 4.938c.992-18.762 4.961-35.547 11.898-52.325 8.926-19.757 21.813-38.515 37.676-54.316 14.875-15.801 33.719-27.637 54.539-36.524 19.828-8.886 42.637-12.843 65.438-12.843 19.832 0 39.66 2.961 57.512 9.875h88.242v167.855L850.719 24.687v207.344c1.98-3.945 4.961-7.89 6.941-11.836 11.895-20.742 27.762-39.504 47.594-54.316 19.828-14.805 42.633-26.66 67.422-32.578 24.785-6.914 49.574-7.903 74.364-4.942 16.86 2.969 32.72 6.914 47.59 13.829v-40.489h90.23v134.285h134.85V101.699h89.24V235c1.98-14.805 5.94-28.633 11.89-42.461 8.93-20.734 20.82-38.508 36.69-54.297 15.86-15.801 34.7-28.644 54.53-37.531 20.82-7.899 42.64-12.832 66.44-12.832 22.8 0 45.6 4.933 65.43 12.832 9.92 4.934 19.83 9.875 28.76 15.801v-14.813h78.33v136.27c0 8.886.99 17.773 4.96 26.656 3.96 7.895 8.92 15.793 15.86 22.711 5.95 5.922 13.88 10.855 22.81 14.809 7.93 3.949 16.85 5.921 26.76 5.921h5.95V101.699h90.23v167.86L2141.68 0v414.707h-89.24"
        style={{
          fill:
            resolvedTheme === "dark" ? "url(#grad-dark)" : "url(#grad-light)",
          // fill: "url(#grad1)",
          fillOpacity: 1,
          fillRule: "evenodd",
          stroke: "none",
        }}
        transform="matrix(.13333 0 0 -.13333 0 72.013)"
        id="grad1"
      />
    </svg>
  );
};

export default EunchurnLogo;
